export const isColorProp = (prop) => ['fill', 'stroke', 'fillStyle', 'strokeStyle'].includes(prop);

export const isGradientColor = (val) => /^[r,R,L,l]{1}[\s]*\(/.test(val);
